"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CardShellRow_1 = require("./CardShellRow");
exports.default = CardShellRow_1.default;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/CardShellRow/index.js
// module id = 1755
// module chunks = 8